// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-sJbl","col":"styles_col__1JOf9"};